import { computed } from 'vue'

import { useBillingStore } from '@/features/billing/store'
import { capitalize } from '@/shared/utils/string'
import { PlatformType } from '@/shared/graphql/legacy/generated'

export type IAPType = 'change' | 'cancel' | 'pay'

export function useIAP(type: IAPType) {
  const billingStore = useBillingStore()

  const platform = computed(() =>
    capitalize(billingStore.billing?.plan.platform || '')
  )

  const isWebPlan = computed(
    () => billingStore.billing?.plan.platform === PlatformType.Web
  )

  const title = computed(() => {
    if (type === 'pay') return "Can't pay here"
    return `Can't ${type} your plan here`
  })

  return { platform, isWebPlan, title }
}
